__turbopack_context__.v({
  "disclaimer": "styles-module-scss-module__1ee-TW__disclaimer",
  "error_style": "styles-module-scss-module__1ee-TW__error_style",
  "form": "styles-module-scss-module__1ee-TW__form",
  "form_bg_img": "styles-module-scss-module__1ee-TW__form_bg_img",
  "form_container": "styles-module-scss-module__1ee-TW__form_container",
  "form_image": "styles-module-scss-module__1ee-TW__form_image",
  "form_inside_container": "styles-module-scss-module__1ee-TW__form_inside_container",
  "form_row": "styles-module-scss-module__1ee-TW__form_row",
  "form_success": "styles-module-scss-module__1ee-TW__form_success",
  "form_support_block": "styles-module-scss-module__1ee-TW__form_support_block",
  "form_support_block_text": "styles-module-scss-module__1ee-TW__form_support_block_text",
  "form_title": "styles-module-scss-module__1ee-TW__form_title",
  "form_wrapper": "styles-module-scss-module__1ee-TW__form_wrapper",
  "previous_step": "styles-module-scss-module__1ee-TW__previous_step",
  "theme_no_background": "styles-module-scss-module__1ee-TW__theme_no_background",
  "theme_no_background_no_padding": "styles-module-scss-module__1ee-TW__theme_no_background_no_padding",
  "theme_office": "styles-module-scss-module__1ee-TW__theme_office",
});
